
import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const ItemProvider = ({ children }) => {
    const [cart, setCartItems] = useState([]);
    const [grandTotal, setGrandTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [searchResults, setSearchResults] = useState([]);
    const [displayedItem,setDisplayedItem]=useState([]);

    console.log("displayedItem", displayedItem);
    
    return (
        <CartContext.Provider value={{ 
            cart, setCartItems, 
            grandTotal, setGrandTotal, displayedItem,setDisplayedItem,
            page, setPage,
            searchResults, setSearchResults }}>
            {children}
        </CartContext.Provider>
    );
};
